export default __webpack_public_path__ + "static/media/slide1.0c1bf5d6.jpg";